var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactMessenger50X50(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25,0 C38.8071,0 50,11.1929 50,25 C50,38.8071 38.8071,50 25,50 C11.1929,50 0,38.8071 0,25 C0,11.1929 11.1929,0 25,0 Z M41.382,17.8044 C42.1342,16.6201 40.6726,15.2811 39.5576,16.1293 L39.5576,16.1293 L31.193,22.4774 C30.6276,22.9042 29.8487,22.9095 29.2779,22.4828 L29.2779,22.4828 L23.0845,17.8364 C21.2281,16.4441 18.5715,16.9348 17.3339,18.898 L17.3339,18.898 L9.5454,31.2528 C8.79324,32.4371 10.2549,33.776 11.3698,32.9278 L11.3698,32.9278 L19.7397,26.5744 C20.3052,26.1476 21.0841,26.1423 21.6549,26.569 L21.6549,26.569 L27.8483,31.2155 C29.7047,32.6078 32.3613,32.117 33.5989,30.1539 L33.5989,30.1539 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactMessenger50X50);
export default __webpack_public_path__ + "static/media/contact-messenger-50x50.0e4c9445.svg";
export { ForwardRef as ReactComponent };